import React from "react";
import { Box } from "@mui/material";

export const Arrow = ({ isOpen, margin, transparent, sx }) => {
  return (
    <Box
      sx={{
        width: "0",
        height: "0",
        borderStyle: "solid",
        borderWidth: "0 5px 5px 4px",
        borderColor: transparent
          ? "transparent transparent transparent transparent"
          : "transparent transparent #999DDB transparent",
        position: "relative",
        transform: `rotate(${isOpen ? 180 : 90}deg)`,
        margin: margin || "0 4px",
        ...sx,
      }}
    />
  );
};
